let configCache = null;

export async function loadConfig() {
    if (configCache) return configCache;
    const response = await fetch('/config.json');
    const contentType = response.headers.get('content-type') || '';
    if (!response.ok || !contentType.includes('json')) {
        throw new Error('config.json not found. Copy public/config.example.json to public/config.json and adjust the settings.');
    }
    try {
        configCache = await response.json();
        // Normalise APIURL: drop trailing slashes so callers can safely do
        // `${APIURL}/licenses/...` without producing a double slash.
        if (typeof configCache.APIURL === 'string') {
            configCache.APIURL = configCache.APIURL.replace(/\/+$/, '');
        }
        return configCache;
    } catch {
        throw new Error('config.json could not be parsed. Make sure it contains valid JSON.');
    }
}